// Selección de plantilla pública del pasaporte (ver src/app/template.service.ts). Cada clave es
// el Template.name real que llega en product.template / workflow.workflowTemplate /
// company.template (backend). No inventa ids: 'green-template'/'gold-template'/
// 'default-template' ya existen como filas de la tabla `templates` (ids 1-3, ver
// product72.json). Para que un producto pueda seleccionar Historia o Mapa, el backend
// necesita una fila `templates` adicional cuyo `name` sea exactamente 'historia-template' o
// 'mapa-template' (mismo mecanismo que las tres plantillas existentes), asignada a
// product.template (o a workflow.workflowTemplate / company.template como fallback, igual que
// hoy) — ver TemplateService.loadTemplate() y product.page.ts. No hace falta ningún cambio de
// contrato ni id nuevo en el frontend para que esto funcione en cuanto exista esa fila.
export const TemplateConfig = {
    templates: {
      'green-template': "dimitra",
      'gold-template': "portesa",
      'default-template': "stelvio",
      'historia-template': "historia",
      'mapa-template': "mapa",
    }
  };
